// extracted by mini-css-extract-plugin
module.exports = {"title_section":"RosetteForm_title_section__v5Kgo","card":"RosetteForm_card__x0XQ_","back":"RosetteForm_back__fmr47"};